import type { LoadNotification } from './types';

/** The pickup-instructions email the "Emailed …" stamp reports on. */
export const PICKUP_EVENT = 'ORDER_READY_FOR_PICKUP';

const EVENT_LABELS: Record<string, string> = {
  ORDER_APPROVED: 'Order approved',
  ORDER_ASSIGNED: 'Carrier assigned',
  ORDER_READY_FOR_PICKUP: 'Pickup instructions',
  ORDER_REJECTED: 'Order rejected',
  ORDER_ENROUTE: 'Order enroute',
  ORDER_DELIVERED: 'Order delivered',
  ORDER_INVOICED: 'Invoice available',
  ORDER_PAID: 'Payment received',
  ORDER_CANCELLED: 'Order cancelled',
  ORDER_PREPAY_REQUIRED: 'Prepayment required',
  ORDER_NOTE_FROM_ORG: 'Note from supplier',
  ORDER_NOTE_FROM_CUSTOMER: 'Note from customer',
};

export const notificationEventLabel = (event: string): string => EVENT_LABELS[event] ?? event;

/** Only a SENT/DELIVERED row means it actually left; PENDING and FAILED did not. */
export const wasDelivered = (n: LoadNotification): boolean =>
  n.status === 'SENT' || n.status === 'DELIVERED';

/**
 * When the customer was last emailed their pickup instructions, or null.
 *
 * Falls back to `createdAt` because `sentAt` is only stamped once the send
 * succeeds, and an older row may predate that write.
 */
export function lastPickupEmailAt(notifications: LoadNotification[]): string | null {
  const sent = notifications
    .filter((n) => n.event === PICKUP_EVENT && wasDelivered(n))
    .map((n) => n.sentAt ?? n.createdAt);

  if (sent.length === 0) return null;

  return sent.reduce((latest, at) => (new Date(at) > new Date(latest) ? at : latest));
}
